import React, { useContext } from 'react'

// Context
import { AppContext, OverlayContext } from '../../../../contexts'

// Components
import { ScrollableContent, Show } from '../../../../components'
import TabContent from '../TabContent'
import OverlayPanels from '../OverlayPanels'

import styles from './Body.module.scss'

const Body = () => {
  const { activeTab } = useContext(AppContext)
  const { activeOverlayId } = useContext(OverlayContext)

  return (
    <div className={styles.analyzeModalBody}>
      <ScrollableContent scrollTopDeps={[activeOverlayId, activeTab]}>
        <Show condition={!activeOverlayId}>
          <TabContent />
        </Show>
        <Show condition={activeOverlayId}>
          <OverlayPanels />
        </Show>
      </ScrollableContent>
    </div>
  )
}

export default Body
